import React, { Component } from "react";
import LoadingPanel from "../../common/LoadingPanel";
import { provideLocalizationService } from "@progress/kendo-react-intl";
import { toolsController } from "../../../controllers/tools.controller";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Checkbox } from "react-bootstrap";
import { Zvuky } from "../../common/Zvuky";
import confirmService from "../../common/confirmService";

class ZoznamUzivatelovDialogContent extends Component {
    state = {
        items: [],
        loading: true
    };

    componentDidMount() {
        toolsController.getUzivateliaZoznam().then((response) => {
            this.setState({
                items: response.items,
                loading: false
            });
        });
    }

    aktivnyCell = (props) => {
        return (
            <td>
                <Checkbox checked={props.dataItem.aktivny} onChange={(e) => this.handleChange(e, props.dataItem)} />
            </td>
        );
    };

    handleChange = async (e, dataItem) => {
        dataItem.aktivny = e.currentTarget.checked;

        var response = await toolsController.setUzivatelStatus(dataItem);
        if (response.isError) {
            Zvuky.playChyba();
            await confirmService.show({
                message: response.errorMessage,
                logMessage: true
            });
            return;
        }

        var items = this.state.items;
        items
            .filter((item) => item.meno === dataItem.meno && item.celeMeno === dataItem.celeMeno && item.typ === dataItem.typ)
            .forEach((i) => {
                i.aktivny = dataItem.aktivny;
            });

        this.setState({
            items: items
        });
    };

    renderDialogContent() {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="ZoznamUzivatelovDialog">
                <Grid data={this.state.items} className="ZoznamUzivatelovGrid">
                    <GridColumn field="meno" title={localizationService.toLanguageString("ZoznamUzivatelov.Grid.Meno", "Meno")} />
                    <GridColumn field="celeMeno" title={localizationService.toLanguageString("ZoznamUzivatelov.Grid.Celé meno", "Celé meno")} />
                    <GridColumn
                        field="typNazev"
                        title={localizationService.toLanguageString("ZoznamUzivatelov.Grid.Typ užívateľa", "Typ užívateľa")}
                        width="80px"
                    />
                    <GridColumn
                        field="pocetPredajni"
                        title={localizationService.toLanguageString("ZoznamUzivatelov.Grid.Počet predajní", "Počet predajní")}
                        width="80px"
                    />
                    <GridColumn cell={this.aktivnyCell} title={localizationService.toLanguageString("ZoznamUzivatelov.Grid.Aktívny", "Aktívny")} width="40px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default ZoznamUzivatelovDialogContent;



// WEBPACK FOOTER //
// ./src/components/views/Tools/ZoznamUzivatelovDialogContent.js